import { render } from "./moduleTitle.vue?vue&type=template&id=7496857b&scoped=true"
import script from "./moduleTitle.vue?vue&type=script&lang=js"
export * from "./moduleTitle.vue?vue&type=script&lang=js"

import "./moduleTitle.vue?vue&type=style&index=0&id=7496857b&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7496857b"]])

export default __exports__